import 'slick-carousel';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import "./sass/style.scss";
import 'viewport-extra';
import simpleParallax from 'simple-parallax-js';

/* ----------------------------------
ローディング
---------------------------------- */

const loading = document.getElementById('loading');
/* 読み込み完了 */
window.addEventListener('load', stopload);

/* 6秒経ったら強制的にロード画面を非表示にする */
setTimeout(stopload,10000, '');

/* ロード画面を非表示にする処理 */
function stopload(){
  if(document.querySelector('#loading') ) {
    loading.classList.add('is-loaded');
  }

  const images = document.querySelectorAll('.parallax');
  new simpleParallax(images, {
    scale: 1.1,
    delay: .4,
    transition: 'cubic-bezier(0,0,0,1)'
  });
  AOS.init({
    offset: 50,
    once: true,
    disable: function () {
      return window.innerWidth < 920;
    }
  });
}

$(function(){

  $('.nav-toggle').on('click', function () {
    $('.gNav').toggleClass('is-active');
    $('.gNav_toggle').toggleClass('active');
    $('.gNav_overlay').toggleClass('open');
    $('.siteHead').toggleClass('visible');
    if ($("body").css('overflow') == 'hidden') {
      $("body").css({ overflow: 'visible' });
    } else if ($("body").css('overflow') == 'visible') {
      $("body").css({ overflow: 'hidden' });
    };
  });

  $('.gNav_list_item_link-toggle').on('click', function () {
    $(this).toggleClass('is-active');
    $(this).next('.gNav_list_sub-accordion').slideToggle();
  });

  $('.product_item_toggle').on('click', function () {
    $(this).toggleClass('is-active');
    $(this).parents('.product_item').find('.product_item_toggleArea').slideToggle();
  });

  $('.recruit_interview_staff_nameArea').on('click', function () {
    $(this).toggleClass('is-active');
    $(this).parents('.recruit_interview_staff').find('.recruit_interview_staff_body').slideToggle();
  });

  $('.faq_q').on('click', function () {
    $(this).toggleClass('is-active');
    $(this).next('.faq_a').slideToggle();
  });

  // #で始まるアンカーをクリックした場合に処理
  $('.smoothScroll').click(function(){
    // 移動先を50px上にずらす
    const adjust = 90;
    // スクロールの速度
    const speed = 400; // ミリ秒
    // アンカーの値取得
    const href= $(this).attr("href");
    // 移動先を取得
    const target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を調整
    const position = target.offset().top - adjust;
    // スムーススクロール
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });

  $(document).ready(function() {
    $.fn.startBar = function(index) {
      this
        .eq(index)
        .animate({ width: '100%' }, 6000 );
    }
    $(".firstView_slider")
      // 最初のスライドに"add-animation"のclassを付ける(data-slick-index="0"が最初のスライドを指す)
      .on("init", function () {
        $('.slick-slide[data-slick-index="0"]').addClass("add-animation");
      })
      // 通常のオプション
      .slick({
        autoplay: true, // 自動再生ON
        fade: true, // フェードON
        arrows: false, // 矢印OFF
        speed: 1000, // スライド、フェードアニメーションの速度1000ミリ秒
        autoplaySpeed: 6000, // 自動再生速度3000ミリ秒
        pauseOnFocus: false, // フォーカスで一時停止OFF
        pauseOnHover: false, // マウスホバーで一時停止OFF
      })
      .on({
        // スライドが移動する前に発生するイベント
        beforeChange: function (event, slick, currentSlide, nextSlide) {
          // 表示されているスライドに"add-animation"のclassをつける
          $(".slick-slide", this).eq(nextSlide).addClass("add-animation");
          // あとで"add-animation"のclassを消すための"remove-animation"classを付ける
          $(".slick-slide", this).eq(currentSlide).addClass("remove-animation");
        },
        // スライドが移動した後に発生するイベント
        afterChange: function (event, slick, currentSlide) {
          // 表示していないスライドはアニメーションのclassを外す
          $(".remove-animation", this).removeClass(
            "remove-animation add-animation"
          );
          if (currentSlide === 0)
            $('.bar').css({width: 0});
          $('.bar').startBar(currentSlide);
        },
      });
    $('.bar').startBar(0);

    $(".season_with_slider")
      // 通常のオプション
      .slick({
        autoplay: false, // 自動再生ON
        fade: false, // フェードON
        arrows: false, // 矢印OFF
        speed: 1000, // スライド、フェードアニメーションの速度1000ミリ秒
        infinite: false,
        asNavFor: '.season_with_textSlider',
        dots: true,
      });
    $(".season_with_textSlider")
      // 通常のオプション
      .slick({
        autoplay: false, // 自動再生ON
        fade: true, // フェードON
        arrows: false, // 矢印OFF
        speed: 1000, // スライド、フェードアニメーションの速度1000ミリ秒
        infinite: false,
        asNavFor: '.season_with_slider',
      });
  });


  $('.front_product_list').slick({
    dots: false,
    infinite: false,
    autoplay: false,
    fade: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          centerMode: false,
          centerPadding: '350px',
          dots: false,
          infinite: true,
          autoplay: false,
          fade: false,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
        }
      },
      {
        breakpoint: 1600,
        settings: {
          centerMode: false,
          centerPadding: '300px',
          dots: false,
          infinite: true,
          autoplay: false,
          fade: false,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
        }
      },
      {
        breakpoint: 1400,
        settings: {
          centerMode: false,
          centerPadding: '200px',
          dots: false,
          infinite: true,
          autoplay: false,
          fade: false,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          centerMode: false,
          centerPadding: '100px',
          dots: false,
          infinite: true,
          autoplay: false,
          fade: false,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
        }
      },
      {
        breakpoint: 920,
        settings: {
          // centerPadding: '50px',
          // centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          variableWidth: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  if(document.querySelector('.stalker') ) {
    $(document).on('mousemove', function(e) {
      $('.stalker').css('transform', `translate(${e.pageX + 15}px, ${e.pageY + 15}px)`)
    })
  }

  if(document.querySelector('.season_stalker') ) {
    $(document).on('mousemove', function(e) {
      $('.season_stalker').css('transform', `translate(${e.clientX + 15}px, ${e.clientY + 15}px)`)
    })
  }

  if(document.querySelector('#insta') ) {
    $(document).ready(function() {
      $.ajax({
        type: 'GET',
        url: 'https://kinseiken.co.jp/get_instagram.php',
        dataType: 'jsonp',
        success: function(json) {
          // success
          const gallery_data = json['media']['data'];
          let photos = "";
          const photo_length = 8;

          // for (var i = 0; i < j.length; i++) {
          //   $('#insta').append('<div class="instagram_item"><a href="' + j[i]['permalink'] + '" target="_blank"><img src="' + j[i]['media_url'] + '" alt=""></a></div>');
          // }
          for(let i = 0; i < photo_length ;i++){

            if(gallery_data[i]['thumbnail_url']){
              photos += '<div class="instagram_item"><a href="' + gallery_data[i]['permalink'] + '" target="_blank"><img src="' + gallery_data[i]['thumbnail_url'] + '"></div>';
            } else {
              photos += '<div class="instagram_item"><a href="' + gallery_data[i]['permalink'] + '" target="_blank"><img src="' + gallery_data[i]['media_url'] + '"></div>';
            }
          }
          document.querySelector("#insta").innerHTML = photos;
        }
      });
    });
  }


  $(".archive-list > li").click(function() {
    //@link: https://stackoverflow.com/questions/6656202/jquery-slidedown-child-ul
    if($(this).next(".month-archive-list").is(":visible") || $(this).hasClass("acv_open")){ //既に開いている場所なら
      $(".month-archive-list", this).slideUp("fast"); //閉じる
      $(this).removeClass("acv_open"); //.acv_open削除

    }
    else { //閉じている場所なら
      $(this).siblings().children(".month-archive-list").slideUp("fast"); //その他のリストを閉じる
      $(".month-archive-list", this).slideDown("fast"); //開く
      $(".year").removeClass("acv_open"); //.acv_open削除
      $(this).addClass("acv_open"); //.acv_open付加
    }
  });

});



/* ----------------------------------
画面高さをCSS変数に代入（100vh用）
---------------------------------- */

const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

let vw = window.innerWidth;

window.addEventListener('resize', () => {
  if (vw === window.innerWidth) {
    // 画面の横幅にサイズ変動がないので処理を終える
    return;
  }

  // 画面の横幅のサイズ変動があった時のみ高さを再計算する
  vw = window.innerWidth;
  setFillHeight();
});

// 初期化
setFillHeight();

/* ----------------------------------
ヘッダー動作
---------------------------------- */
const wrapper = document.querySelector('#pagetop');
const header = document.querySelector('.siteHead');
if(document.querySelector('.firstView') ) {
  const headHiddenOptions = {
    root: null, // 今回はビューポートをルート要素とする
    rootMargin: "", // ビューポートの中心を判定基準にする
    threshold: 0.5 // 閾値は0
  };
  const fvObserver = new IntersectionObserver(doHidden, headHiddenOptions);
  fvObserver.observe(document.querySelector('.firstView'));
  function doHidden(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        wrapper.classList.add('is-front');
      }else{
        wrapper.classList.remove('is-front');
      }
    });
  }
};

